import { initInteractions } from "./interactions.js";
import { initMotion } from "./motion.js";
import { initNebulaParticles } from "./nebula-particles.js";
import { createPage } from "./view.js";

const root = document.querySelector("#app");
const currentPage = document.body.dataset.page ?? "home";

const renderError = () => {
  document.body.classList.remove("is-loading");
  document.body.style.background = "#050509";
  document.body.style.color = "#fbfbff";
  document.body.style.fontFamily = "sans-serif";

  if (root) {
    root.innerHTML = `
      <main style="min-height:100vh;display:grid;place-items:center;padding:2rem;text-align:center">
        <div>
          <h1 style="font-size:clamp(2rem,6vw,5rem);margin:0 0 1rem">页面加载未完成</h1>
          <p style="margin:0;color:#a5a8ba">请刷新页面；如果问题持续，请检查本地文件是否完整。</p>
        </div>
      </main>
    `;
  }
};

const bootstrap = () => {
  if (!root) {
    renderError();
    return;
  }

  try {
    root.innerHTML = createPage(currentPage);
    const particleField = initNebulaParticles();
    initInteractions();
    initMotion({ particleField });
  } catch (error) {
    console.error("Failed to initialize Shanying Nebula website", error);
    renderError();
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  bootstrap();
}
